export function generateUniqueNumber() {
  return Math.floor(Math.random() * 1000000); // Adjust the range as needed
}
